import authorCodeMixin from './authorCode';
import loadingMixin from './loading';
import checkboxMixin from './checkbox';
import exportMixin from './export';
import dataTableScrollFixedMixin from './dataTableScrollFixed';
import tableScrollFixedMixin from './tableScrollFixed';
import setTagsAliveMixin from './setTagsAlive';
import checkboxNewMixin from './checkboxNew';

export {
    authorCodeMixin,
    loadingMixin,
    checkboxMixin,
    exportMixin,
    dataTableScrollFixedMixin,
    tableScrollFixedMixin,
    setTagsAliveMixin,
    checkboxNewMixin
}